import React from 'react'
import PropTypes from 'prop-types'

function LiteratureDocs({ literature, handleSubscriptionClick }) {
  return (
    <>
      {literature.map((doc, i) => {
        return (
          <div key={'doc' + i} className="u-textNoWrap u-marginBottom3gu">
            <input
              checked={doc.selected}
              id={'modal-doc' + doc.id}
              onChange={handleSubscriptionClick}
              value={doc.id}
              type="checkbox"
              className="Subscription-checkbox"
              data-analytics="cesc-subscribe-checkbox"
            ></input>
            <label htmlFor={'modal-doc' + doc.id}>
              <p className="u-inlineBlock u-marginLeft1gu">
                {doc.name.indexOf('Fund Commentary') > 0
                  ? 'Commentary'
                  : doc.name}
                {doc.frequency && (
                  <span className="u-textItalic"> - {doc.frequency}</span>
                )}
              </p>
            </label>
          </div>
        )
      })}
    </>
  )
}

LiteratureDocs.propTypes = {
  literature: PropTypes.array.isRequired,
  handleSubscriptionClick: PropTypes.func,
}

export default LiteratureDocs
